import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from "../img/logo.jpg";

// Extend jsPDF type to include autoTable
declare module 'jspdf' {
  interface jsPDF {
      autoTable: any;
      lastAutoTable: any;

    }
}

export const generatePDF = (order: any) => {
  const doc = new jsPDF();

  // Add Receipt Header
  doc.setFontSize(20);
  doc.text("RECEIPT", 15, 20);

  // Add Company Details
  doc.setFontSize(12);
  doc.text("COZY BUD (PVT) LTD", 15, 30);

  // Add Payment Details
  doc.text("Order Date:", 150, 30, { align: "right" });
  doc.text(`${new Date(order.order_date.seconds * 1000).toLocaleString()}`, 195, 30, { align: "right" });

  doc.text("Tracking Number:", 150, 40, { align: "right" });
  doc.text(`${order.tracking_number || "N/A"}`, 195, 40, { align: "right" });

  doc.text("Payment Method:", 150, 50, { align: "right" });
  doc.text(`${order.payment_method || "N/A"}`, 195, 50, { align: "right" });

  doc.text("Courier Charge:", 150, 60, { align: "right" });
  doc.text("LKR "+order.courier_charge.toFixed(2).toString(), 195, 60, { align: "right" });

  // Add Logo Placeholder (You can replace this with an actual image)
  doc.addImage(logo, 'JPG', 15, 40, 25, 25);

  var tableData: any = []
  order.items.forEach((item: any) => {
    // Add Table Section
    tableData.push({
      itemName: item.item_name,
      color: item.color,
      size: item.size,
      quantity: item.quantity.toString(),
      unitPrice: `LKR ${item.unit_price.toFixed(2)}`,
      totalPrice: `LKR ${item.total_price.toFixed(2)}`,
    });
  });

  // Use autoTable function directly
  autoTable(doc, {
    startY: 100,
    head: [
      [
        "Item Name",
        "Color",
        "Size",
        "Quantity",
        "Unit Price",
        "Total Price",
      ],
    ],
    body: tableData.map((row: any) => [
      row.itemName,
      row.color,
      row.size,
      row.quantity,
      row.unitPrice,
      row.totalPrice,
    ]),
    theme: "grid",
      headStyles: {
      // Option 1: Darker blue (current)
      fillColor: [100, 149, 237], // Darker blue that prints well
      
      textColor: [255, 255, 255], // White text color
      fontStyle: "bold",
      lineColor: [0, 0, 0], // Black border for header
      lineWidth: 0.2,
    },
    bodyStyles: {
      lineColor: [0, 0, 0], // Black grid lines for body
      lineWidth: 0.2,
      textColor: [0, 0, 0], // Black text for better printing
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245], // Light gray for alternate rows (prints well)
      lineColor: [0, 0, 0],
      lineWidth: 0.2,
    },
    styles: {
      fontSize: 10,
      cellPadding: 3,
      valign: 'middle',
      halign: 'center',
    },
    columnStyles: {
      0: { halign: 'left' }, // Item name left-aligned
      4: { halign: 'right' }, // Unit price right-aligned
      5: { halign: 'right' }, // Total price right-aligned
    },
  });

  // Add Total Section
  const finalY = (doc as any).lastAutoTable.finalY || 120;
  doc.setFontSize(12);
  doc.text("Total Price:", 160, finalY + 10, { align: "right" });
  doc.text(`LKR ${order.total_price.toFixed(2)}`, 195, finalY + 10, { align: "right" });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Thank you line
  doc.setFontSize(12);
  doc.text(
    "Thank you for your order – we appreciate your trust in Cozy Bud",
    pageWidth / 2,
    pageHeight - 35,
    { align: "center" }
  );

  // Contact & links
  doc.setFontSize(10);
  doc.text(
    "Website: https://cozybud.shop   |   Facebook: https://www.facebook.com/cozybud   |   WhatsApp: +94 74 356 4344",
    pageWidth / 2,
    pageHeight - 20,
    { align: "center" }
  );

  return doc;
};
